/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const cloud_upload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#cloud_upload_svg__a)">
      <path
        fill="#000"
        d="m3.559 4.83.139.737-.14-.737Zm8.728 1.211-.742-.11a.75.75 0 0 0 .8.858l-.058-.748Zm-6.942-.194a.75.75 0 0 0 .748-1.3l-.748 1.3Zm1.826 8.996a.75.75 0 0 0 1.5 0h-1.5Zm2.108-2.93a.75.75 0 0 0 1.06-1.061l-1.06 1.06ZM7.92 9.493l.53-.53a.75.75 0 0 0-1.06 0l.53.53Zm-2.418 1.358a.75.75 0 0 0 1.061 1.06l-1.06-1.06Zm-2.776.699a.75.75 0 0 0 .546-1.397l-.546 1.397Zm10.12-1.27a.75.75 0 0 0 .306 1.467l-.306-1.468ZM1.75 7.92c0-1.17.839-2.145 1.948-2.354L3.42 4.093A3.897 3.897 0 0 0 .25 7.921h1.5Zm2.554-3.006C4.527 2.97 6.268 1.75 7.92 1.75V.25c-2.29 0-4.784 1.675-5.106 4.495l1.49.17ZM7.92 1.75c2.417 0 3.92 2.18 3.624 4.182l1.484.219C13.44 3.356 11.364.25 7.92.25v1.5Zm4.423 5.039c1.006-.078 1.906.752 1.906 1.762h1.5c0-1.888-1.648-3.402-3.521-3.258l.115 1.496ZM3.698 5.567a2.428 2.428 0 0 1 1.647.28l.748-1.3a3.928 3.928 0 0 0-2.673-.454l.278 1.474Zm6.641 5.285L8.452 8.964l-1.06 1.06 1.887 1.888 1.06-1.06ZM7.391 8.964l-1.888 1.888 1.061 1.06 1.888-1.887-1.06-1.061Zm1.28 5.879V9.494h-1.5v5.349h1.5Zm-5.398-4.69A2.397 2.397 0 0 1 1.75 7.922H.25a3.897 3.897 0 0 0 2.477 3.63l.546-1.397ZM14.25 8.552a1.77 1.77 0 0 1-1.403 1.73l.306 1.467a3.268 3.268 0 0 0 2.597-3.197h-1.5Z"
      />
    </g>
    <defs>
      <clipPath id="cloud_upload_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cloud_upload
